var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c(_setup.EnvironmentFloat,{attrs:{"current-environment":_setup.currentEnvironment},on:{"switch":_setup.switchToStandardEnv}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }